module.exports = __webpack_public_path__ + "img/order4.c2aba227.png";